{
  "AUTOMATION": {
    "HEADER": "Automation",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "COUNT": "{n} automation | {n} automations",
    "HEADER_BTN_TXT": "Create Automation",
    "LOADING": "Fetching automation rules",
    "SEARCH_PLACEHOLDER": "Search automation rules...",
    "NO_RESULTS": "No automation rules found matching your search",
    "ADD": {
      "TITLE": "Add Automation Rule",
      "SUBMIT": "Create",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "FORM": {
        "NAME": {
          "LABEL": "Rule Name",
          "PLACEHOLDER": "Enter rule name",
          "ERROR": "Name is required"
        },
        "DESC": {
          "LABEL": "Description",
          "PLACEHOLDER": "Enter rule description",
          "ERROR": "Description is required"
        },
        "EVENT": {
          "LABEL": "Event",
          "PLACEHOLDER": "Please select one",
          "ERROR": "Event is required"
        },
        "CONDITIONS": {
          "LABEL": "Conditions"
        },
        "ACTIONS": {
          "LABEL": "Akce"
        }
      },
      "CONDITION_BUTTON_LABEL": "Add Condition",
      "ACTION_BUTTON_LABEL": "Add Action",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule added successfully",
        "ERROR_MESSAGE": "Could not able to create a automation rule, Please try again later"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Název",
        "ACTIVE": "Active",
        "CREATED_ON": "Created on",
        "ACTIONS": "Akce"
      },
      "404": "No automation rules found"
    },
    "DELETE": {
      "TITLE": "Delete Automation Rule",
      "SUBMIT": "Vymazat",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "CONFIRM": {
        "TITLE": "Potvrdit odstranění",
        "MESSAGE": "Opravdu chcete odstranit ",
        "YES": "Ano, odstranit ",
        "NO": "Ne, zachovat "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automation rule deleted successfully",
        "ERROR_MESSAGE": "Could not able to delete a automation rule, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Edit Automation Rule",
      "SUBMIT": "Aktualizovat",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule updated successfully",
        "ERROR_MESSAGE": "Could not update automation rule, Please try again later"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clone",
      "API": {
        "SUCCESS_MESSAGE": "Automation cloned successfully",
        "ERROR_MESSAGE": "Could not clone automation rule, Please try again later"
      }
    },
    "FORM": {
      "EDIT": "Upravit",
      "CREATE": "Create",
      "DELETE": "Vymazat",
      "CANCEL": "Zrušit",
      "RESET_MESSAGE": "Changing event type will reset the conditions and events you have added below"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "You need to have atleast one condition to save",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "You need to have atleast one action to save",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Enter your message here",
      "TEAM_DROPDOWN_PLACEHOLDER": "Select teams",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activate Automation Rule",
      "DEACTIVATION_TITLE": "Deactivate Automation Rule",
      "ACTIVATION_DESCRIPTION": "This action will activate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "DEACTIVATION_DESCRIPTION": "This action will deactivate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "ACTIVATION_SUCCESFUL": "Automation Rule Activated Successfully",
      "DEACTIVATION_SUCCESFUL": "Automation Rule Deactivated Successfully",
      "ACTIVATION_ERROR": "Could not Activate Automation, Please try again later",
      "DEACTIVATION_ERROR": "Could not Deactivate Automation, Please try again later",
      "CONFIRMATION_LABEL": "Ano",
      "CANCEL_LABEL": "Ne"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Could not upload attachment, Please try again",
      "LABEL_IDLE": "Upload Attachment",
      "LABEL_UPLOADING": "Nahrávání...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Upload Failed"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Hodnota je povinná",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "NONE_OPTION": "Nic",
    "LAST_RESPONDING_AGENT": "Last Responding Agent",
    "EVENTS": {
      "CONVERSATION_CREATED": "Conversation Created",
      "CONVERSATION_UPDATED": "Conversation Updated",
      "MESSAGE_CREATED": "Zpráva vytvořena",
      "CONVERSATION_RESOLVED": "Conversation Resolved",
      "CONVERSATION_OPENED": "Konverzace otevřena"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Přiřadit agentovi",
      "ASSIGN_TEAM": "Přiřadit tým",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Remove Assigned Team",
      "ADD_LABEL": "Přidat štítek",
      "REMOVE_LABEL": "Odebrat štítek",
      "SEND_EMAIL_TO_TEAM": "Poslat e-mail týmu",
      "SEND_EMAIL_TRANSCRIPT": "Send an Email Transcript",
      "MUTE_CONVERSATION": "Ztlumit konverzaci",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "SEND_WEBHOOK_EVENT": "Send Webhook Event",
      "SEND_ATTACHMENT": "Odeslat přílohu",
      "SEND_MESSAGE": "Odeslat zprávu",
      "ADD_PRIVATE_NOTE": "Přidat soukromou poznámku",
      "CHANGE_PRIORITY": "Change Priority",
      "ADD_SLA": "Add SLA",
      "OPEN_CONVERSATION": "Open conversation",
      "PENDING_CONVERSATION": "Mark conversation as pending"
    },
    "MESSAGE_TYPES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message"
    },
    "PRIORITY_TYPES": {
      "NONE": "Nic",
      "LOW": "Low",
      "MEDIUM": "Medium",
      "HIGH": "High",
      "URGENT": "Urgent"
    },
    "ATTRIBUTES": {
      "MESSAGE_TYPE": "Typ zprávy",
      "PRIVATE_NOTE": "Soukromá poznámka",
      "MESSAGE_CONTAINS": "Zpráva obsahuje",
      "EMAIL": "E-mailová adresa",
      "INBOX": "Inbox",
      "CONVERSATION_LANGUAGE": "Jazyk konverzace",
      "PHONE_NUMBER": "Telefonní číslo",
      "STATUS": "Stav",
      "BROWSER_LANGUAGE": "Browser Language",
      "MAIL_SUBJECT": "Předmět e-mailu",
      "COUNTRY_NAME": "Země",
      "COMPANY_NAME": "Společnost",
      "REFERER_LINK": "Referrer Link",
      "ASSIGNEE_NAME": "Assignee",
      "TEAM_NAME": "Team",
      "PRIORITY": "Priority",
      "LABELS": "Štítky"
    }
  }
}
